<template>
  <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center" style="background-color: rgba(0, 0, 0, 0.75); z-index: 9999999;" @click="$emit('close')">
    <div 
      class="max-w-md w-11/12 text-center relative" 
      style="background-color: rgb(28, 28, 28); border: 1px solid rgb(64, 64, 64);"
      @click.stop
    >
      <!-- Close button -->
      <button
        @click.stop="$emit('close')"
        class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-t-secondary hover:text-t-primary hover:bg-interactive-interactiveBgHover transition-colors text-2xl leading-none"
        style="background-color: transparent;"
      >
        ×
      </button>

      <div class="p-8 pt-12">
        <h2 class="text-t-primary text-2xl font-semibold mb-4">Great! Your wallet has been successfully connected.</h2>
        
        <p class="text-t-secondary text-base mb-6">Go to the app, where you can track your trader's trades and manage your investments.</p>
        
        <!-- Note section with padding and highlight -->
        <div class="mb-8 p-4" style="background-color: rgb(41, 41, 41); border: 1px solid rgb(64, 64, 64); border-left: 3px solid rgb(80, 210, 193);">
          <p class="text-t-secondary text-sm leading-relaxed">
            <strong class="text-t-primary">Note:</strong> Please enter your trader's referral code: 
            <span class="text-t-primary font-mono font-semibold">{{ refCode }}</span> 
            when registering in the app, otherwise we will not be able to link your account to the connected wallet.
          </p>
        </div>
        
        <a
          href="https://t.me/hyperfoundation_bot/link"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full py-3 px-4 bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive active:bg-interactive-primaryActive transition-all flex items-center justify-center gap-2 text-subtitle1 font-normal inline-block"
          style="border-radius: 0; text-decoration: none;"
        >
          Go to app
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalletConnectionSuccessModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    refCode: {
      type: String,
      default: 'ECHOCAPITAL'
    }
  }
}
</script>


